import { ConfigType } from '@copilot/data/config/types';

const Config: ConfigType = window.runtimeConfig;

export const BASE_URL = Config.apiURL;
export const USERPILOT_APP_KEY = Config.userpilotAppKey ?? 'no-key-provided';

export const LAUNCH_DARKLY_ID = Config.launchDarklyId ?? 'no-key-provided';
export const CS_DASH_LAUNCH_DARKLY_ID = Config.csDashLaunchDarklyId ?? 'no-key-provided';
export const WELL_KNOWN_TENANT = Config.wellKnownTenant ?? 'CopilotAi';
export const PAYMENT_URL = Config.paymentURL;
export const PAYMENT_PRODUCT_URL = Config.paymentProductURL;
export const USER_INTEREST_URL = Config.userInterestsURL;
export const CRM_ACCOUNT_API_URL = Config.crmAccountApiURL;

export namespace BACKEND_ROUTES {
    export const AUTHENTICATION = {
        Login: `${BASE_URL}/auth/login`,
        ResetPassword: `${BASE_URL}/auth/resetpassword`,
        SetPassword: `${BASE_URL}/auth/setpassword`,
        Identify: `${BASE_URL}/auth/identify`,
        ChangeOrg: `${BASE_URL}/auth/changeorg`,
    };

    export const CAMPAIGN = {
        Default: `${BASE_URL}/api/campaigns`,
        LinkedIn: `${BASE_URL}/api/linkedin/campaigns`,
        Create: `${BASE_URL}/api/linkedin/campaigns/prospecting`,
        IndividualUserCreate: `${BASE_URL}/api/linkedin/campaigns/individual/prospecting`,
        Onboard: `${BASE_URL}/api/linkedin/onboard/campaign`,
        NurtureOnboard: `${BASE_URL}/api/linkedin/nurture/onboard/campaign`,
    };

    export const INBOX = {
        Default: `${BASE_URL}/api/inbox`,
        V3: `${BASE_URL}/api/inbox/v3`,
        V4: `${BASE_URL}/api/inbox/v4`,
        SendMessageAndResumeAutomation: `${BASE_URL}/api/linkedin/campaigns/send-message-and-resume-automation`,
        Campaign: `${BASE_URL}/api/inbox/campaigns`,
        Connections: `${BASE_URL}/connections`,
        Threads: `${BASE_URL}/threads`,
    };

    export const OUTBOX = {
        Default: `${BASE_URL}/api/outbox`,
    };

    export const CONTACT = {
        Default: `${BASE_URL}/api/contacts`,
        Export: `${BASE_URL}/api/export/connections/list`,
    };

    export const LINKED_IN = {
        Onboard: `${BASE_URL}/api/linkedin/onboard`,
        NurtureOnboard: `${BASE_URL}/api/linkedin/nurture/onboard`,
        SendMessage: `${BASE_URL}/api/inbox/sendmessage`,
        InitMember: `${BASE_URL}/api/linkedin/campaigns`,
        MemberInfo: `${BASE_URL}/api/linkedin/campaigns`,
        OrgInfo: `${BASE_URL}/api/linkedin/organizations`,
        Members: `${BASE_URL}/api/linkedin/members`,
    };

    export const MESSAGE = {
        Default: `${BASE_URL}/api/limessages`,
    };

    export const NOTIFICATIONS = {
        Default: `${BASE_URL}/api/notification`,
        Settings: `${BASE_URL}/api/notification/settings`,
    };

    export const ORGANIZATION = {
        Default: `${BASE_URL}/api/organizations`,
    };

    export const TEMPLATE = {
        Default: `${BASE_URL}/api/templates`,
    };

    export const ORGANIZATION_MEMBER = {
        Default: `${BASE_URL}/api/members`,
        Me: `${BASE_URL}/api/members/me`,
        Crm: `${BASE_URL}/api/members/crm`,
        ResetMySalesNavErrorStatus: `${BASE_URL}/api/members/me/clear-sales-nav-error`,
        DisconnectLinkedIn: `${BASE_URL}/api/members/me/disconnect-linkedin`,
        ResetPassword: `${BASE_URL}/auth/requestresetpassword`,
    };

    export const ADMIN = {
        Organizations: `${BASE_URL}/api/admin/organizations`,
        OrgMembers: `${BASE_URL}/api/admin/orgmembers`,
        AdminMember: `${BASE_URL}/api/admin/adminmembers`,
        AdminMemberDetails: `${BASE_URL}/api/admin/adminmembers/details`,
        CS: `${BASE_URL}/api/admin/cs`,
        Client: `${BASE_URL}/api/admin/client`,
        Teams: `${BASE_URL}/api/admin/teams`,
        Instance: `${BASE_URL}/api/admin/instance`,
    };

    export const TASK = {
        LinkedIn: `${BASE_URL}/api/linkedin/campaigns`,
    };

    export const SCHEDULE = {
        Default: `${BASE_URL}/api/schedules`,
    };

    export const CHANGES = {
        Default: `${BASE_URL}/api/organizations`,
    };

    export const SETTINGS = {
        FE: `${BASE_URL}/api/settings/fe`,
        SERVER: `${BASE_URL}/api/settings/fe/server`,
    };

    export const FILTER_TEMPLATES = {
        Default: `${BASE_URL}/api/filtertemplate`,
    };

    export const CATEGORY = {
        Campaign: `${BASE_URL}/api/campaigns/categories`,
    };

    export const BILLING = {
        Info: `${PAYMENT_URL}/api/billingInfo`,
        IndividualInfo: `${PAYMENT_PRODUCT_URL}/api/individualBillingInfo`,
        Products: `${PAYMENT_PRODUCT_URL}/api/mainProducts`,
        Coupons: `${PAYMENT_PRODUCT_URL}/api/coupons`,
        PreviewSubscription: `${PAYMENT_PRODUCT_URL}/api/invoices/preview`,
        Subscription: `${PAYMENT_PRODUCT_URL}/api/subscriptions`,
    };

    export const ATTENTION_ITEMS = {
        Default: `${BASE_URL}/api/attentionItems`,
    };

    export const CONNECTIONS_VIEW = {
        Default: `${BASE_URL}/api/connections`,
    };

    export const SELF_SERVE = {
        Default: `${BASE_URL}/api/settings/fe/selfServe`,
    };

    // TODO: sync up about route once BE is finalized
    export const USER_INTERESTS = {
        Default: `${USER_INTEREST_URL}/api/interests`,
    };

    export const SMART_REPLY = {
        Default: `${BASE_URL}/api/smartReply`,
    };

    export const AI_FEATURE = {
        Default: `${BASE_URL}/api/aiFeature`,
    };

    export const ACCOUNT_FEATURE = {
        Default: `${BASE_URL}/api/account`,
    };

    export const CRM_ACCOUNT_API = {
        Default: CRM_ACCOUNT_API_URL,
        GetCustomerToken: `${CRM_ACCOUNT_API_URL}/token`,
        GetAccessToken: `${CRM_ACCOUNT_API_URL}/auth`,
        SsoMethods: `${CRM_ACCOUNT_API_URL}/sso`,
    };
}

const baseB2CRoute = `https://${Config.b2cLoginDomainName}/${Config.b2cTenantId}`;
export const B2CCustomPolicyRoutes = {
    SignIn: `${baseB2CRoute}/${Config.b2cSignInPolicy}`,
    SignUp: `${baseB2CRoute}/${Config.b2cSignupPolicy}`,
    ChangeToken: `${baseB2CRoute}/${Config.b2cChangeTokenPolicy}`,
    Impersonation: `${baseB2CRoute}/${Config.b2cImpersonationPolicy}`,
};
